export class AuthError extends Error {
  constructor(message) {
    super(message);
    this.name = 'AuthError';
  }
}

export class GraphqlError extends Error {
  constructor(message, operationName) {
    super(message);
    this.name = `GraphqlError:${operationName}`;
  }
}
